import {useSelector} from 'react-redux';

import {Session} from 'nutshell-core/session';

import {CalendarRegularPenIcon} from 'shells/icon/svg/calendar-regular-pen-icon';
import {CalendarSquareRegularEventIcon} from 'shells/icon/svg/calendar-square-regular-event-icon';
import {LockRegularIcon} from 'shells/icon/svg/lock-regular-icon';
import {SecondarySidebar} from 'shells/navigation/secondary-sidebar/secondary-sidebar';
import type {NavItem} from 'shells/navigation/types';

import type {NutshellState} from '../../store';

export function SchedulerSidebarEmbedded() {
    const user = useSelector((state: NutshellState) => Session.getSessionStateUser(state));

    const navItems: NavItem[] = [
        {
            id: 'overview',
            label: 'Overview',
            icon: CalendarRegularPenIcon,
            to: '/sales/scheduler',
            activeMatch: /\/sales\/scheduler(?!\/(managed|calendar-settings)).*/,
        },
        {
            id: 'calendar-settings',
            label: 'Calendar settings',
            icon: CalendarSquareRegularEventIcon,
            to: '/sales/scheduler/calendar-settings',
            activeMatch: /\/sales\/scheduler\/calendar-settings/,
        },
    ];

    const MANAGED_MEETINGS_ITEM: NavItem = {
        id: 'managed-meetings',
        label: 'Managed meetings',
        icon: LockRegularIcon,
        to: '/sales/scheduler/managed',
    };

    // @ts-expect-error
    if (user.permissions.canAccessSetup) {
        navItems.push(MANAGED_MEETINGS_ITEM);
    }

    return <SecondarySidebar navItems={navItems} isEmbedded={true} />;
}
